import type { UserInfo } from '@shared/models';
import { create } from 'zustand';

export interface Conversation {
  conversationid: number;
}

export interface AppState {
  userInfo?: UserInfo;
  isAuthorized: boolean;
  filter: string;
  setUserInfo: (userInfo: UserInfo | undefined) => void;
  setIsAuthorized: (isAuthorized: boolean) => void;
  setFilter: (filter: string) => void;
}

export const useAppStore = create<AppState>()((set) => ({
  userInfo: undefined,
  isAuthorized: true,
  filter: '',
  setUserInfo: (userInfo) => set(() => ({ userInfo })),
  setIsAuthorized: (isAuthorized) => set(() => ({ isAuthorized })),
  setFilter: (filter) => set(() => ({ filter })),
}));
